import { render } from "./DealerBenefits.vue?vue&type=template&id=5b42c2d8"
const script = {}

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__